module.exports = __webpack_public_path__ + "7fbe5070177a2f7bdd7af6707b0069a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sap_america_2022_chart.png
// module id = 1731
// module chunks = 0